const DEFAULT_CDN = 'https://s91588.cdn.ngenix.net';
const ANALYTICS_PRECONNECTED_DOMAINS = [
    'https://www.googletagmanager.com',
    'https://www.google-analytics.com',
    'https://mc.yandex.ru',
    'https://www.gstatic.com',
];

export { ANALYTICS_PRECONNECTED_DOMAINS, DEFAULT_CDN };
//# sourceMappingURL=consts.js.map
